import * as yup from 'yup'

const baseMemberSchema = yup.object({
  firstName: yup
    .string()
    .required('Please provide the first name')
    .matches(/^[a-zA-Z\s]*$/, 'Please provide a valid first name'),
  lastName: yup
    .string()
    .notRequired()
    .matches(/^[a-zA-Z\s]*$/, 'Please provide a valid last name'),
  dob: yup.string().required('Please provide the date of birth'),
  relation: yup.string(),
  phoneNumber: yup
    .string()
    .notRequired()
    .test('len', 'Phone number must be at least 10 digits', (value) => {
      return !value || /^\d{10}$/.test(value)
    }),
  gender: yup.string().required('Please provide the gender'),
  email: yup
    .string()
    .notRequired()
    .email('Please provide a valid email'),
})

export const memberOnboardingSchema = baseMemberSchema

export const memberFamilySchema = baseMemberSchema.shape({
  relation: yup.string().required('Please specify the relation'),
})
